import React, { useMemo } from 'react';
import { Button, Form, Input, Space, Typography } from 'antd';
import { LeftOutlined, CloseOutlined } from '@ant-design/icons';
import { DEFAULT_CUSTOM_PROMPT_TEMPLATE } from './llmJudgeDefaults';

const { Text } = Typography;

const BuiltinCriteriaViewer = ({
  title,
  promptTemplate,
  onBack,
  onCancel,
  onOk,
}) => {
  const [form] = Form.useForm();

  const init = useMemo(() => ({
    promptTemplate: promptTemplate || DEFAULT_CUSTOM_PROMPT_TEMPLATE,
  }), [promptTemplate]);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Space>
          <Button type="text" icon={<LeftOutlined />} onClick={onBack} />
          <Text style={{ fontWeight: 500, fontSize: 16 }}>{title}</Text>
        </Space>
        <Button type="text" icon={<CloseOutlined />} onClick={onCancel} />
      </div>

      <Form
        form={form}
        layout="vertical"
        initialValues={init}
        style={{ marginTop: 16 }}
      >
        <Form.Item label={<Text style={{ fontSize: 14, fontWeight: 400 }}>Evaluation Prompt Template</Text>} name="promptTemplate">
          <Input.TextArea disabled rows={12} />
        </Form.Item>
      </Form>

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, marginTop: 16 }}>
        <Button onClick={onCancel}>Cancel</Button>
        <Button
          type="primary"
          onClick={() => {
            onOk?.();
          }}
        >
          Ok
        </Button>
      </div>
    </div>
  );
};

export default BuiltinCriteriaViewer;

